import NonMowingForm from '@/views/original-mydot/non-mowing/NonMowingForm.vue';
import lsQuerystringService from '@/services/querystring/querystring.service';
import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { serviceType, INTENT_KEY } from '@/constants';
// eslint-disable-next-line import/no-cycle
import router from '.';

const paramToRouteDict = {
    'non-mowing': {
        name: 'nonMowingForm',
        component: NonMowingForm,
        meta: {
            showOrderSummary: false,
            showAddress: true,
        },
    },
};

export function resolveIntent(route, setIntent) {
    const { TREATMENT, MOWING } = serviceType;
    const isTreatment = route.params.intent === TREATMENT;
    const intentValue = isTreatment ? TREATMENT : MOWING;

    sessionStorage.setItem('intentReferer', route.params.intent);
    sessionStorage.setItem(INTENT_KEY, intentValue);
    setIntent(intentValue);
}

export const singleStepSignupFormBeforeEnter = ({ fromRoute, next }) => {
    const validParams = lsQuerystringService.checkParams(fromRoute.params);

    if (lsQuerystringService.checkFormName(_.get(validParams, 'formName'))) {
        const { formName } = validParams;
        const { name, meta, component } = paramToRouteDict[formName];

        return router.push({
            path: formName,
            name,
            meta,
            component,
        });
    }

    const isLead = _.get(validParams, 'lead') === '1';

    if (isLead && _.get(store, 'state.order.customer_leads_enabled')) {
        return router.push({
            name: 'nonMowingForm',
            component: NonMowingForm,
            meta: {
                showOrderSummary: false,
                showAddress: true,
            },
        });
    }

    if (
        !_.get(store, 'state.order.zip_in_market') ||
        !_.get(store, 'state.order.zip_is_active') ||
        _.isEmpty(_.get(store, 'state.order.services'))
    ) {
        // go back to where they're coming from as there is no pricing
        return router.push({ ...fromRoute });
    }

    return next();
};

export const lsRouterHelpers = {
    singleStepSignupFormBeforeEnter,
};
